// AIM Score data for each page
// WAVE Accessibility Impact (AIM) score measures the impact of accessibility issues
// on users with disabilities. Scores range from 1-10, where 5 is average.
// Higher scores indicate better accessibility.

export const AIM_SCORE_DESCRIPTION =
  'WAVE Accessibility Impact (AIM) score measures the impact of accessibility issues on users with disabilities. Scores range from 1-10, where 5 is average. Higher scores indicate better accessibility.';

export const aimScores = {
  '/': { score: 9.7 }, // User will provide
  '/about': { score: 9.9 },
  '/experience': { score: 9.7 },
  '/endorsements': { score: 9.9 },
  '/widgets': { score: 9.8 },
  '/contact': { score: 9.9 },
};
